// components
import SvgIconStyle from '../../../components/SvgIconStyle';
import { PATH_EMPLOYEE, PATH_PATIENT } from '../../../routes/paths';
import { ROLES } from '../../../utils/enums';
// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  accounting: getIcon('ic_accounting'),
  analytics: getIcon('ic_analytics'),
  banking: getIcon('ic_banking'),
  blog: getIcon('ic_blog'),
  book: getIcon('ic_book'),
  booking: getIcon('ic_booking'),
  calendar: getIcon('ic_calendar'),
  cart: getIcon('ic_cart'),
  cash_stack: getIcon('ic_cash_stack'),
  chat: getIcon('ic_chat'),
  dashboard: getIcon('ic_dashboard'),
  ecommerce: getIcon('ic_ecommerce'),
  grade: getIcon('ic_grade'),
  graph_paper: getIcon('ic_graph_paper'),
  group: getIcon('ic_group'),
  guidance: getIcon('ic_guidance'),
  home: getIcon('ic_home'),
  invoice: getIcon('ic_invoice'),
  kanban: getIcon('ic_kanban'),
  list: getIcon('ic_list'),
  mail: getIcon('ic_mail'),
  menu_item: getIcon('ic_menu_item'),
  paper_scroll: getIcon('ic_paper_scroll'),
  receipt: getIcon('ic_receipt'),
  records: getIcon('ic_records'),
  school: getIcon('ic_school'),
  setting: getIcon('ic_setting'),
  user: getIcon('ic_user'),
  doctor: getIcon('ic_doctor'),
  employee: getIcon('ic_employee'),
};

const navConfig = [
  {
    items: [
      { title: 'Home', path: PATH_EMPLOYEE.employeeHome, icon: ICONS.home, roles: ROLES.employee },
      { title: 'Manager Dashboard', path: PATH_EMPLOYEE.managerDash, icon: ICONS.dashboard, roles: ROLES.clinicManager },
      { title: 'Inventory Dashboard', path: PATH_EMPLOYEE.inventoryDash, icon: ICONS.list, roles: ROLES.inventoryManager },

      { title: 'Shop Preview', path: PATH_EMPLOYEE.shop, icon: ICONS.cart, roles: ROLES.inventoryManager, },

      {
        title: 'Appointments', path: PATH_EMPLOYEE.appointments,
        icon: ICONS.calendar,
        roles: ROLES.employee,
        children: [
          { title: 'Today', path: PATH_EMPLOYEE.appointmentList, roles: ROLES.employee },
          { title: 'Set an Appointment', path: PATH_EMPLOYEE.appointmentCreate, roles: ROLES.employee.filter(role => role !== 'hr'), },
        ],
      },

      {
        title: 'Patients',
        path: PATH_EMPLOYEE.patients,
        icon: ICONS.user,
        // employee except hr
        roles: ROLES.employee.filter(role => role !== 'hr'),
        children: [
          {
            title: 'Medical Records',
            path: PATH_EMPLOYEE.medicalRecords,
            roles: ROLES.employee.filter(role => role !== 'hr'),
          },
          {
            title: 'Profiles',
            path: PATH_EMPLOYEE.patientList,
            roles: ROLES.employee.filter(role => role !== 'hr'),
          }, {
            title: 'Create New Profile',
            path: PATH_EMPLOYEE.patientCreate,
            roles: ROLES.employee.filter(role => role !== 'hr'),
          },
        ],
      },
      {
        title: 'Employees',
        path: PATH_EMPLOYEE.employees,
        icon: ICONS.employee,
        roles: [...ROLES.clinicManager, 'hr' ],
        children: [
          {
            title: 'List', path: PATH_EMPLOYEE.employeeList,
            roles: [...ROLES.clinicManager, 'hr'],
          }, {
            title: 'Doctors', path: PATH_EMPLOYEE.doctorList,
            roles: [...ROLES.clinicManager, 'hr'],
          }, {
            title: 'Therapists', path: PATH_EMPLOYEE.therapistList,
            roles: [...ROLES.clinicManager, 'hr'],
          }, {
            title: 'Add', path: PATH_EMPLOYEE.employeeCreate,
            roles: [...ROLES.clinicManager, 'hr'],
          }, {
            title: 'Payroll Entries', path: PATH_EMPLOYEE.salaryPayrollEntries,
            roles: [...ROLES.hr],
          }
        ],
      },
      {
        title: 'Manage Attendance',
        path: PATH_EMPLOYEE.attendance,
        icon: ICONS.guidance,
        roles: [...ROLES.clinicManager, 'hr'],
        children: [
          {
            title: 'View Records', path: PATH_EMPLOYEE.attendanceRecords,
            roles: [...ROLES.clinicManager, 'hr'],
          }, {
            title: 'Leave Requests', path: PATH_EMPLOYEE.requestsLeave,
            roles: [...ROLES.clinicManager, 'hr'],
          }, {
            title: 'Attendance Edit Requests', path: PATH_EMPLOYEE.attendanceEditRequests,
            roles: [...ROLES.clinicManager, 'hr'],
          }, {
            title: 'Overtime Requests', path: PATH_EMPLOYEE.requestsOvertime,
            roles: [...ROLES.clinicManager, 'hr'],
          }
        ],
      },
      // attendance self
      {
        title: 'My Attendance',
        path: PATH_EMPLOYEE.myAttendance,
        icon: ICONS.guidance,
        roles: ROLES.employee,
        children: [
          { title: 'My Attendance', path: PATH_EMPLOYEE.myAttendanceRecords, roles: ROLES.employee },
          { title: 'My Leave Requests', path: PATH_EMPLOYEE.myAttendanceLeaveRequests, roles: ROLES.employee },
          { title: 'My Edit Requests', path: PATH_EMPLOYEE.myAttendanceEditRequests, roles: ROLES.employee },
          { title: 'My Overtime Requests', path: PATH_EMPLOYEE.myOvertimeRequests, roles: ROLES.employee },
        ]
      },
      {
        title: 'My Commissions',
        path: PATH_EMPLOYEE.myCommissions,
        icon: ICONS.invoice,
        roles: ROLES.employee,
      },
      {
        title: "Manage Cash Funds",
        path: PATH_EMPLOYEE.cashFunds,
        icon: ICONS.cash_stack,
        roles: ROLES.clinicManager,
        children: [
          { title: 'Cash Funds', path: PATH_EMPLOYEE.cashFunds, roles: ROLES.clinicManager },
          { title: 'Cash Requests', path: PATH_EMPLOYEE.cashRequests, roles: ROLES.clinicManager },
        ]
      },
      {
        title: "My Cash Requests",
        path: PATH_EMPLOYEE.myCashRequests,
        icon: ICONS.cash_stack,
        roles: ROLES.employee
      },
      {
        title: 'Products',
        path: PATH_EMPLOYEE.products,
        icon: ICONS.ecommerce,
        roles: ROLES.employee.filter(role => role !== 'hr'),
        children: [
          {
            title: 'List', path: PATH_EMPLOYEE.productList,
            roles: ROLES.employee.filter(role => role !== 'hr'),
          }, {
            title: 'Create', path: PATH_EMPLOYEE.productCreate,
            roles: ROLES.employee.filter(role => role !== 'hr'),
          }
        ],
      },

      // INVENTORY MANAGER NAVIGATION
      { 
        title: 'Inventory List',
        path: PATH_EMPLOYEE.inventoryList,
        icon: ICONS.list,
        roles: ROLES.employee.filter(role => role !== 'hr'),
      },

      {
        title: 'Transactions',
        path: PATH_EMPLOYEE.transactions,
        icon: ICONS.invoice,
        roles: ROLES.employee.filter(role => role !== 'hr'),
        children: [
          { title: 'Service Slip', path: PATH_EMPLOYEE.transactionCreate, roles: ROLES.employee.filter(role => role !== 'hr'), },
          { title: 'Transaction History', path: PATH_EMPLOYEE.transactionList, roles: ROLES.employee.filter(role => role !== 'hr'), },
          { title: 'Online Shop Orders', path: PATH_EMPLOYEE.transactionsOnline, roles: ROLES.employee.filter(role => role !== 'hr'), },
          { title: 'Commissions', path: PATH_EMPLOYEE.transactionCommissions, roles: ROLES.admin, },
        ]
      },

      // Employee Navs
      // { title: 'Employee Dashboard', path: PATH_EMPLOYEE.home, icon: ICONS.booking, roles: ROLES.employee },

      {
        title: 'Reports',
        path: PATH_EMPLOYEE.reports,
        icon: ICONS.invoice,
        roles: ROLES.clinicManager,
        children: [
          { title: 'Sales Reports', path: PATH_EMPLOYEE.reportSales, roles: ROLES.clinicManager },
          { title: 'Commission Report', path: PATH_EMPLOYEE.reportCommissions, roles: ROLES.admin },
          { title: 'Evaluations', path: PATH_EMPLOYEE.reportEvaluations, roles: [...ROLES.clinicManager, 'hr'] },
          { title: '1st Month Evaluation Form', path: PATH_EMPLOYEE.reportForm1, roles: [...ROLES.clinicManager, 'hr'] },
          { title: '3rd Month Evaluation Form', path: PATH_EMPLOYEE.reportForm2, roles: [...ROLES.clinicManager, 'hr'] },
          { title: 'Management Evaluation Form', path: PATH_EMPLOYEE.reportForm3, roles: ROLES.admin },
        ]
      },
      {
        title: 'Booking Blocks',
        icon: ICONS.booking,
        roles: [...ROLES.admin, ...ROLES.clinicManager],
        path: PATH_EMPLOYEE.bookingBlocks,
      },
      {
        title: 'Settings',
        icon: ICONS.setting,
        roles: ROLES.clinicManager,
        path: PATH_EMPLOYEE.settings,
      },


      // PATIENT NAVIGATION
      { title: 'Home', path: PATH_PATIENT.root, icon: ICONS.home, roles: ROLES.patient },
      { title: 'Shop', path: PATH_PATIENT.shop, icon: ICONS.cart, roles: ROLES.patient, },
      { title: 'My Appointments', path: PATH_PATIENT.myAppointments, icon: ICONS.calendar, roles: ROLES.patient },
      { title: 'My Orders', path: PATH_PATIENT.myOrders, icon: ICONS.records, roles: ROLES.patient },
      {
        title: 'Set an Appointment',
        path: PATH_PATIENT.appointments,
        icon: ICONS.booking,
        roles: ROLES.patient,
      },


      // {
      //   title: 'administrator',
      //   path: '/admin/administrator',
      //   roles: ROLES.administrator,
      //   icon: ICONS.setting,
      //   children: [
      //     // { title: 'Departments', path: '/admin/administrator/departments' },
      //     // { title: 'Announcements', path: '/admin/administrator/announcements' },
      //     // { title: 'Employees', path: '/admin/administrator/employees' },
      //     { title: 'Settings', path: '/admin/administrator/settings' },
      //   ].map(v => ({ ...v, roles: ROLES.administrator })),
      // },
    ],
  },
];

if (!Array.isArray(navConfig)) {
  throw new Error('navConfig must be an array');
}

navConfig?.forEach((item) => {
  item?.items?.forEach((subItem) => {
    if (!subItem.title || !subItem.path) {
      // show what element is missing
      console.error('Each navConfig item must have a title and path', subItem);
      throw new Error('Each navConfig item must have a title and path');
    }
  })
})

export default navConfig;
